import React from 'react'
import './contactusmain.scss'
import { MainHeading,Helpyou, ContactForm } from '../../components';
import { Container } from 'react-bootstrap';
const Contactus = () => {

    return (
        <div className='contactus_wapper'>
            <Container>
                <MainHeading title="Contact us" showshare={false} />
                <Helpyou/>
                <ContactForm/>
            </Container>
        </div>
    )
}

export default Contactus;